module.exports = __webpack_public_path__ + "static/media/slideshow-45.4ab34a2d.jpg";